import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6d2b3c0e&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2b3c0e",
  null
  
)


    import installComponents from "!C:/Projects/rentmagic.website.vue.limburg/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormInput, BFormGroup, BButton, BInputGroupAppend, BInputGroup, BCol, BRow, BForm, BCard} from 'bootstrap-vue'
    installComponents(component, {BFormInput, BFormGroup, BButton, BInputGroupAppend, BInputGroup, BCol, BRow, BForm, BCard})
    

export default component.exports